/* wh1-policies.js : WILDHORN DARK policy pages (POLICIES builder, theme 188568469748).
   1:1 port of the preview /site/policies/<handle> pages:
     markup    = /root/workspace/wildhorn-lp/site/tools/policies/gen.py  (clean, lead card, dl blocks, headings, chrome)
     behaviour = /root/workspace/wildhorn-lp/site/tools/policies/policies.js (sticky contents, copy link, back to top)
   Shopify renders /policies/<handle> with its own fixed markup (.shopify-policy__container, no template), so the
   preview layout is rebuilt here, client side, from the policy text Shopify printed. The legal text is never retyped:
   only the preview's typographic edits are applied (see gen.py clean()).
   Also drives the policies index page (template page.wh1-policies). */
(function () {
  'use strict';
  var d = document, W = window;

  var EMAIL = 'hello@trywildhorn.com';
  var PHONE = '+1 (855) 507-9329';
  var TEL = 'tel:+18555079329';
  var GUARANTEE = '60-day money-back guarantee.';
  var ALL_URL = '#pol-more'; /* qafix-2609: /pages/policies does not exist -> the Other policies block below */
  var HELP_URL = '/pages/help';
  /* the Subscription policy card opens the store's subscription policy (same link as the footer menu) */
  var SUB_URL = '/policies/subscription-policy';

  /* handle, short title, h1 html, lede, card description (gen.py POLICIES) */
  var POLICIES = [
    ['privacy-policy', 'Privacy policy', 'Privacy <span>policy</span>',
      'What we collect when you visit or order, why we collect it, and the choices you have over your data.',
      'What we collect, why we collect it, and your rights over your data.'],
    ['refund-policy', 'Refund policy', 'Refund <span>policy</span>',
      GUARANTEE + ' The full conditions are below.', GUARANTEE],
    ['shipping-policy', 'Shipping policy', 'Shipping <span>policy</span>',
      'Processing times, delivery estimates, tracking and customs, all in one place.',
      'Processing times, delivery estimates, tracking and customs.'],
    ['terms-of-service', 'Terms of service', 'Terms of <span>service</span>',
      'The terms of sale that apply when you order from Wildhorn.',
      'The terms of sale that apply to every order.'],
    ['subscription-policy', 'Subscription policy', 'Subscription <span>policy</span>',
      'The subscription terms from our Terms of service and Refund policy, gathered on one page.',
      'How your subscription is billed, adjusted and canceled.'],
    ['contact-information', 'Contact information', 'Contact <span>information</span>',
      'Who we are and how to reach the Wildhorn support team.',
      'Company details, support hours and response times.'],
    ['legal-notice', 'Legal notice', 'Legal <span>notice</span>',
      'Who publishes this website and the law that governs it.',
      'Who publishes this website and the law that applies.']
  ];
  var BY = {};
  POLICIES.forEach(function (p) { BY[p[0]] = p; });

  function policyUrl(h) { return h === 'subscription-policy' ? SUB_URL : '/policies/' + h; }

  var EM_FIXES = [
    ['Shopify Payments \u2014 we never store', 'Shopify Payments; we never store'],
    ['per order</strong> \u2014 the jar you actually tried', 'per order</strong>, the jar you actually tried'],
    [EMAIL + ' \u2014 We aim to respond', EMAIL + '. We aim to respond'],
    ['All content on this website \u2014 including', 'All content on this website, including'],
    ['graphics, and design \u2014 is the property', 'graphics, and design, is the property']
  ];

  var ICON = {
    cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="2.5"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg>',
    list: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1.2" fill="currentColor" stroke="none"/><circle cx="4.5" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="4.5" cy="18" r="1.2" fill="currentColor" stroke="none"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>',
    doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true"><path d="M7 3.5h7l4.5 4.5v12.5H7z"/><path d="M14 3.5V8h4.5M10 12.5h5.5M10 16h5.5"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>',
    up: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>',
    chev: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M3 6l5 5 5-5"/></svg>',
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M20 12H5M11 6l-6 6 6 6"/></svg>'
  };
  var ANCHOR_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3' +
    'a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2"/><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2"/></svg>';

  /* ------------------------------------------------------------ helpers (python semantics) */
  var ta = d.createElement('textarea');
  function unescapeHtml(s) { ta.innerHTML = s; return ta.value; }
  function stripTags(s) { return unescapeHtml(s.replace(/<[^>]+>/g, '')).trim(); }
  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
  }
  function replaceAll(s, a, b) { return s.split(a).join(b); }
  function pyRound(x) { var f = Math.floor(x), r = x - f; if (r > 0.5) return f + 1; if (r < 0.5) return f; return f % 2 === 0 ? f : f + 1; }
  function slug(s) {
    s = replaceAll(stripTags(s).toLowerCase(), '&', ' ');
    s = s.replace(/^\s*\d+(\.\d+)*\.?\s*/, '');
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function clean(body) {
    body = body.replace(/<span>(?:\s|&nbsp;|\u00a0)*<\/span>/g, ' ');
    body = replaceAll(body, ' dir="ltr"', '');
    body = body.replace(/<p>\s*<br>\s*<\/p>/g, '');
    var docTitle = null, m = /^\s*<h1>([\s\S]*?)<\/h1>/.exec(body);
    if (m) { docTitle = stripTags(m[1]); body = body.slice(m[0].length); }
    body = body.trim().replace(/\s*<hr>\s*$/, '');
    ['\ud83d\udce7', '\ud83d\udcde', '\u23f1\ufe0f', '\u23f1'].forEach(function (emo) {
      body = body.replace(new RegExp(emo + '\\s*', 'g'), '');
    });
    body = body.replace(/<strong>([^<]*?)\s+:<\/strong>/g, '<strong>$1:</strong>');
    body = body.replace(/(\d+)\s*\u2013\s*(\d+)/g, '$1 to $2');
    EM_FIXES.forEach(function (f) { if (body.indexOf(f[0]) > -1) body = replaceAll(body, f[0], f[1]); });
    return { title: docTitle, body: body };
  }

  var FIELD_SEG = /^<strong>([^<:]{1,30}):<\/strong>\s*([^<]{1,160})$/;
  function fieldPairs(inner) {
    var segs = inner.split(/<br\s*\/?>/).map(function (s) { return s.trim(); }).filter(Boolean);
    var out = [];
    for (var i = 0; i < segs.length; i++) {
      var m = FIELD_SEG.exec(segs[i]);
      if (!m) return null;
      out.push([m[1].trim(), m[2].trim()]);
    }
    return out.length ? out : null;
  }

  function linkify(s) {
    var parts = s.split(/(<a\b[\s\S]*?<\/a>|<[^>]+>)/);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (!p || p.charAt(0) === '<') continue;
      p = replaceAll(p, EMAIL, '<a href="mailto:' + EMAIL + '">' + EMAIL + '</a>');
      p = replaceAll(p, PHONE, '<a href="' + TEL + '">' + PHONE + '</a>');
      parts[i] = p;
    }
    return parts.join('');
  }

  function splitLead(body) {
    var m = /<h[23][ >]/.exec(body);
    return m ? [body.slice(0, m.index), body.slice(m.index)] : [body, ''];
  }

  function parseLead(lead) {
    var fields = [], dates = [], keep = [], re = /<p>([\s\S]*?)<\/p>/g, m;
    while ((m = re.exec(lead))) {
      var pairs = fieldPairs(m[1].trim());
      if (pairs) {
        pairs.forEach(function (kv) {
          var k = kv[0].toLowerCase();
          if (k === 'effective date' || k === 'last updated') dates.push(kv); else fields.push(kv);
        });
      } else keep.push(m[0]);
    }
    return { fields: fields, dates: dates, keep: keep };
  }

  function dlBlocks(sections) {
    function repl(chunk) {
      var items = [], re = /<p>([\s\S]*?)<\/p>/g, m;
      while ((m = re.exec(chunk))) items = items.concat(fieldPairs(m[1].trim()));
      return '<dl class="pol-dl">' + items.map(function (kv) {
        return '<div><dt>' + kv[0] + '</dt><dd>' + linkify(kv[1]) + '</dd></div>';
      }).join('') + '</dl>';
    }
    var out = [], buf = [], pos = 0, m;
    var re = /<p>([\s\S]*?)<\/p>|<(h[23]|ul|ol|dl)\b[\s\S]*?<\/\2>/g;
    while ((m = re.exec(sections))) {
      var between = sections.slice(pos, m.index);
      if (between.trim()) {
        if (buf.length) { out.push(['dl', buf]); buf = []; }
        out.push(['raw', between]);
      }
      pos = m.index + m[0].length;
      if (m[1] !== undefined && fieldPairs(m[1].trim()) !== null) buf.push(m[0]);
      else {
        if (buf.length) { out.push(['dl', buf]); buf = []; }
        out.push(['raw', m[0]]);
      }
    }
    if (buf.length) out.push(['dl', buf]);
    var tail = sections.slice(pos);
    if (tail.trim()) out.push(['raw', tail]);
    return out.map(function (x) { return x[0] === 'dl' ? repl(x[1].join('')) : x[1]; })
      .filter(function (x) { return x.trim(); }).map(function (x) { return x.trim(); }).join('\n');
  }

  function headings(body) {
    if (!/<h2[ >]/.test(body) && /<h3[ >]/.test(body)) body = body.replace(/<(\/?)h3>/g, '<$1h2>');
    var toc = [], used = {};
    body = body.replace(/<(h[23])>([\s\S]*?)<\/\1>/g, function (_all, tag, inner) {
      inner = inner.trim();
      var base = slug(inner) || 'section', sid = base, n = 2;
      while (used[sid]) { sid = base + '-' + n; n++; }
      used[sid] = 1;
      var nm = /^(\d+(?:\.\d+)*\.?)\s+([\s\S]*)$/.exec(inner);
      var num = nm ? nm[1] : '', label = nm ? nm[2] : inner;
      if (tag === 'h2') toc.push([sid, num, label]);
      var numh = num ? '<span class="pol-n">' + num + '</span> ' : '';
      return '<' + tag + ' id="' + sid + '">' + numh + label + '<a class="pol-anchor" href="#' + sid +
        '" aria-label="Copy the link to ' + esc(stripTags(label)) + '">' + ANCHOR_SVG + '</a></' + tag + '>';
    });
    return { body: body, toc: toc };
  }

  function entityCard(fields) {
    var order = ['Company Name', 'Legal Entity', 'Country', 'Address', 'Email', 'Phone'];
    var idx = function (k) { var i = order.indexOf(k); return i < 0 ? 99 : i; };
    fields = fields.map(function (kv, i) { return [kv, i]; })
      .sort(function (a, b) { return (idx(a[0][0]) - idx(b[0][0])) || (a[1] - b[1]); })
      .map(function (x) { return x[0]; });
    return '<div class="pol-ent"><dl>' + fields.map(function (kv) {
      return '<div' + (kv[0] === 'Address' ? ' class="w"' : '') + '><dt>' + kv[0] + '</dt><dd>' + linkify(kv[1]) + '</dd></div>';
    }).join('') + '</dl></div>';
  }

  function words(s) {
    var t = stripTags(s.replace(/<svg\b[\s\S]*?<\/svg>/g, ' '));
    return t ? t.split(/\s+/).filter(Boolean).length : 0;
  }

  function otherCards(current) {
    return POLICIES.filter(function (p) { return p[0] !== current; }).map(function (p) {
      return '<a class="card pol-card" href="' + policyUrl(p[0]) + '">' +
        '<span class="pol-card__ic">' + ICON.doc + '</span>' +
        '<span class="pol-card__t">' + p[1] + '</span>' +
        '<span class="pol-card__d">' + p[4] + '</span>' +
        '<span class="pol-card__go">Read ' + ICON.arrow + '</span></a>';
    }).join('\n');
  }

  function helpStrip() {
    return '<div class="pol-help">' +
      '<div class="pol-help__txt"><h2 class="h3">Questions about <span>a policy?</span></h2>' +
      '<p>Write to <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> or call <a href="' + TEL + '">' + PHONE + '</a>. ' +
      'We aim to reply within 24 to 48 business hours.</p></div>' +
      '<div class="pol-help__btns"><a class="btn btn--sm" href="' + HELP_URL + '">Help center ' + ICON.arrow + '</a>' +
      '<a class="btn btn--ghost btn--sm" href="mailto:' + EMAIL + '">Email us</a></div></div>';
  }

  function heroHtml(handle, shopTitle) {
    var p = BY[handle];
    if (p) return [p[2], p[3]];
    var t = (shopTitle || 'Policy').trim(), i = t.lastIndexOf(' ');
    return [i > 0 ? esc(t.slice(0, i)) + ' <span>' + esc(t.slice(i + 1)) + '</span>' : '<span>' + esc(t) + '</span>', ''];
  }

  function build(handle, rteHtml, shopTitle) {
    var c = clean(rteHtml);
    var sl = splitLead(c.body);
    var lead = parseLead(sl[0]);
    var h = headings(sl[1]);
    var toc = h.toc;
    var leadHtml = lead.keep.map(linkify).join('\n');
    var bodyHtml = linkify(dlBlocks(h.body));
    bodyHtml = replaceAll(bodyHtml, 'in accordance with our Privacy Policy',
      'in accordance with our <a href="/policies/privacy-policy">Privacy Policy</a>');
    var prose = (leadHtml + '\n' + bodyHtml).trim();
    var mins = Math.max(1, pyRound(words(prose) / 230));
    var chips = lead.dates.map(function (kv) {
      return '<li class="pol-chip">' + ICON.cal + '<span>' + (kv[0].toLowerCase().indexOf('effective') === 0 ? 'Effective' : 'Last updated') + ' ' + kv[1] + '</span></li>';
    });
    if (toc.length) chips.push('<li class="pol-chip">' + ICON.list + '<span>' + toc.length + (toc.length === 1 ? ' section' : ' sections') + '</span></li>');
    chips.push('<li class="pol-chip">' + ICON.clock + '<span>' + mins + ' min read</span></li>');
    var hasToc = toc.length >= 4;
    var numbered = toc.some(function (t) { return t[1]; });
    function tocItems() {
      return toc.map(function (t) {
        return '<li><a href="#' + t[0] + '">' + (t[1] ? '<span class="n">' + t[1] + '</span>' : '') + '<span class="t">' + t[2] + '</span></a></li>';
      }).join('');
    }
    var tocSide = '', tocMob = '';
    if (hasToc) {
      tocSide = '<aside class="pol-side" aria-label="On this page"><p class="kicker">On this page</p>' +
        '<ol class="pol-toc' + (numbered ? ' pol-toc--num' : '') + '">' + tocItems() + '</ol>' +
        '<a class="pol-all" href="' + ALL_URL + '">' + ICON.back + ' All policies</a></aside>';
      tocMob = '<details class="pol-tocm"><summary><span>On this page</span>' +
        '<span class="pol-tocm__r"><small>' + toc.length + (toc.length === 1 ? ' section' : ' sections') + '</small>' + ICON.chev + '</span></summary>' +
        '<ol class="pol-toc' + (numbered ? ' pol-toc--num' : '') + '">' + tocItems() + '</ol></details>';
    }
    var ent = lead.fields.length ? entityCard(lead.fields) : '';
    var hero = heroHtml(handle, shopTitle);
    var out = [];
    out.push('<section class="sec sec--tight sec--glow pol-hero">\n<div class="wrap wrap--mid">\n' +
      '<p class="eyebrow"><span>Policies</span></p>\n' +
      '<h1 class="h1" id="pol-title" tabindex="-1">' + hero[0] + '</h1>\n' +
      (hero[1] ? '<p class="lede">' + hero[1] + '</p>\n' : '') +
      '<ul class="pol-meta" aria-label="About this document">' + chips.join('') + '</ul>\n' +
      '</div>\n</section>');
    out.push('<section class="sec sec--flush-top pol-main">\n<div class="wrap">\n<div class="pol-grid' + (hasToc ? '' : ' pol-grid--solo') + '">\n' + tocSide + '\n' +
      '<article class="pol-doc" aria-labelledby="pol-title">\n' + tocMob + '\n' + ent + '\n' +
      '<div class="prose pol-body">\n' + prose + '\n</div>\n' +
      '<p class="pol-end"><svg viewBox="0 0 512 512" aria-hidden="true"><use href="#bisonx"/></svg>' +
      '<span>Morvane LLC, the company behind Wildhorn</span></p>\n' +
      '</article>\n</div>\n</div>\n</section>');
    out.push('<section class="sec sec--tight sec--line pol-more" id="pol-more" aria-labelledby="pol-more-h">\n<div class="wrap">\n' +
      '<div class="pol-more__head"><h2 class="h2" id="pol-more-h">Other <span>policies</span></h2>' +
      '<a class="pol-all pol-all--head" href="' + ALL_URL + '">All policies ' + ICON.arrow + '</a></div>\n' +
      '<div class="pol-cards">\n' + otherCards(handle) + '\n</div>\n' + helpStrip() + '\n</div>\n</section>');
    out.push('<a class="pol-top" href="#MainContent" aria-label="Back to top">' + ICON.up + '</a>');
    return out.join('\n') + '\n';
  }

  /* ------------------------------------------------------------ rebuild the Shopify policy page */
  function rebuild() {
    var body = d.body;
    if (!body || !body.classList.contains('wh1-pt-policy')) return false;
    var box = d.querySelector('.shopify-policy__container');
    var rte = box && box.querySelector('.shopify-policy__body .rte');
    if (!box || !rte) { body.classList.add('wh1-pol-fail'); return false; }
    try {
      var handle = (location.pathname.replace(/\/+$/, '').split('/').pop() || '').toLowerCase();
      var h1 = box.querySelector('.shopify-policy__title h1');
      var wrap = d.createElement('div');
      wrap.className = 'wh1-sc wh1-pol';
      wrap.innerHTML = build(handle, rte.innerHTML, h1 ? h1.textContent : '');
      box.parentNode.insertBefore(wrap, box);
      box.parentNode.removeChild(box);
      body.classList.add('wh1-pol-ready');
      /* a #hash in the URL: jump there now that the ids exist */
      if (location.hash.length > 1) {
        var t = d.getElementById(decodeURIComponent(location.hash.slice(1)));
        if (t) t.scrollIntoView();
      }
      return true;
    } catch (e) {
      body.classList.add('wh1-pol-fail');
      if (W.console) console.error('wh1-policies', e);
      return false;
    }
  }

  /* ------------------------------------------------------------ policies index (page.wh1-policies) */
  function fillIndex() {
    var srcs = [].slice.call(d.querySelectorAll('template[data-pol-src]'));
    if (!srcs.length || !d.querySelector('.wh1-pol-idx')) return;
    var docs = {};
    srcs.forEach(function (t) {
      try {
        var c = clean(t.innerHTML);
        docs[t.getAttribute('data-pol-src')] = parseLead(splitLead(c.body)[0]);
      } catch (e) { /* keep the row without a date */ }
    });
    [].slice.call(d.querySelectorAll('.pol-row__date[data-pol]')).forEach(function (el) {
      var doc = docs[el.getAttribute('data-pol')];
      if (doc && doc.dates.length) {
        var kv = doc.dates[0];
        el.innerHTML = ICON.cal + (kv[0].toLowerCase().indexOf('effective') === 0 ? 'Effective' : 'Updated') + ' ' + kv[1];
      }
    });
    var src = (docs['contact-information'] && docs['contact-information'].fields.length) ? docs['contact-information'] : docs['privacy-policy'];
    var box = d.querySelector('[data-pol-ent]');
    if (box && src && src.fields.length) {
      box.outerHTML = entityCard(src.fields);
      var wrap = d.querySelector('.pol-idx-ent');
      if (wrap) wrap.hidden = false;
    }
  }

  /* ------------------------------------------------------------ behaviour (policies.js) */
  function behave() {
    var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var side = d.querySelector('.pol-side');
    var doc = d.querySelector('.pol-doc');
    var links = [].slice.call(d.querySelectorAll('.pol-side .pol-toc a'));
    var heads = links.map(function (a) { return d.getElementById(a.getAttribute('href').slice(1)); });
    var topBtn = d.querySelector('.pol-top');
    if (!side && !topBtn) return;
    var cur = -1, tick = false;
    function limit() {
      var v = parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--hdr-h'));
      return (isNaN(v) ? 86 : v) + 48;
    }
    function upd() {
      tick = false;
      var y = W.pageYOffset || d.documentElement.scrollTop;
      if (topBtn) topBtn.classList.toggle('show', y > 700);
      if (!heads.length || !side || side.offsetParent === null) return;
      var lim = limit(), idx = 0;
      for (var i = 0; i < heads.length; i++) {
        if (heads[i] && heads[i].getBoundingClientRect().top <= lim) idx = i;
      }
      if (doc && doc.getBoundingClientRect().bottom <= W.innerHeight) idx = heads.length - 1;
      if (idx === cur) return;
      cur = idx;
      links.forEach(function (a, i) {
        var on = i === idx;
        a.classList.toggle('on', on);
        if (on) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      });
      if (side.scrollHeight > side.clientHeight + 4) {
        side.scrollTop = Math.max(0, links[idx].offsetTop - side.clientHeight / 2);
      }
    }
    W.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    W.addEventListener('resize', function () { cur = -1; upd(); });
    upd();

    /* phone contents: close after a jump */
    var tm = d.querySelector('.pol-tocm');
    if (tm) tm.addEventListener('click', function (e) { if (e.target.closest('.pol-toc a')) tm.open = false; });

    /* heading links: jump there and copy the link */
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.pol-anchor');
      if (!a) return;
      var url = location.origin + location.pathname + a.getAttribute('href');
      if (navigator.clipboard && W.isSecureContext) {
        navigator.clipboard.writeText(url).then(function () { if (W.WH && W.WH.toast) W.WH.toast('Link copied.'); }, function () {});
      }
    });

    /* back to top */
    if (topBtn) topBtn.addEventListener('click', function (e) {
      e.preventDefault();
      W.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var h = d.getElementById('pol-title');
      if (h) { try { h.focus({ preventScroll: true }); } catch (err) { h.focus(); } }
      if (history.replaceState && location.hash) history.replaceState(null, '', location.pathname + location.search);
    });
  }

  function init() {
    rebuild();
    fillIndex();
    if (d.querySelector('.wh1-pol')) behave();
  }
  W.WH1Policies = { build: build, clean: clean };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
